<template>
  <div id="app">
    <div class="d-flex justify-center mx-2 mt-15 w-100" fluid>
      <v-card class="px-2 w-50">
        <v-alert
          type="warning"
          class="mt-1 mb-0"
          v-if="parseInt(tempLogin.data.status_new_pass) === 0"
        >
          You use the default password, immediately change your password for the
          security of your account
        </v-alert>
        <ValidationObserver ref="form" v-slot="{ handleSubmit }">
          <v-form @submit.prevent="handleSubmit(submitForm)">
            <v-row>
              <v-col cols="12" lg="12" md="12" sm="12" xs="12" class="pb-0">
                <p class="app-title-small text-sm ma-0">
                  Current password
                </p>
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Current password"
                  rules="required"
                >
                  <v-text-field
                    v-model="currentPass"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show1 ? 'text' : 'password'"
                    :error-messages="errors"
                    @click:append="show1 = !show1"
                    single-line
                    dense
                    outlined
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" lg="12" md="12" sm="12" xs="12" class="pt-0">
                <p class="app-title-small text-sm ma-0">
                  New Password
                </p>
                <ValidationProvider
                  v-slot="{ errors }"
                  rules="required|min:6"
                  vid="confirm"
                  name="New Password"
                >
                  <v-text-field
                    v-model="confirmation"
                    :error-messages="errors"
                    single-line
                    dense
                    :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show2 ? 'text' : 'password'"
                    @click:append="show2 = !show2"
                    outlined
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" lg="12" md="12" sm="12" xs="12" class="pt-0">
                <p class="app-title-small text-sm ma-0">
                  Confrim Password
                </p>
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Confrim Password"
                  rules="required|password:@confirm"
                >
                  <v-text-field
                    v-model="password"
                    :error-messages="errors"
                    single-line
                    dense
                    type="password"
                    outlined
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" lg="12" md="12" sm="12" xs="12" class="pt-2">
                <v-btn
                  type="submit"
                  color="#31c0b9"
                  class="text-center ma-1"
                  width="100%"
                  dark
                  :loading="loading"
                  small
                >
                  <span class="text-capitalize">Change</span>
                </v-btn>
                <v-btn
                  color="#008ef8"
                  @click.prevent="closeSuccessNavigate"
                  class="text-center ma-1"
                  width="100%"
                  dark
                  text
                  v-if="parseInt(tempLogin.data.status_new_pass) !== 0"
                  small
                >
                  <span class="text-capitalize">Cancel</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </ValidationObserver>
      </v-card>
      <!-- dialog success -->
      <v-dialog v-model="dialog" persistent max-width="350">
        <v-card class="pa-8 pb-10 d-flex flex-column justify-center">
          <v-icon color="green" size="100px">mdi-checkbox-marked-circle</v-icon>
          <v-card-title class="title-card mx-auto text-center"
            >Update Password Success</v-card-title
          >
          <v-card-actions class="pa-0">
            <v-spacer></v-spacer>
            <v-btn
              @click.prevent="closeSuccessNavigate"
              color="green"
              :loading="loading"
              class="mt-3 w-full"
              width="100%"
              dark
            >
              <span class="text-capitalize">Okay</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- dialog failed -->
      <v-dialog v-model="dialog2" persistent max-width="350">
        <v-card class="pa-8 pb-10 d-flex flex-column justify-center">
          <v-icon color="#F32626" size="100px">mdi-alert-circle-outline</v-icon>
          <v-card-title class="title-card mx-auto text-center"
            >Update Password Failed</v-card-title
          >
          <p class="mx-auto">{{ errorMessage }}</p>
          <v-card-actions class="pa-0">
            <v-spacer></v-spacer>
            <v-btn
              @click.prevent="dialog2 = false"
              color="green"
              class="mt-3 w-full"
              width="100%"
              dark
            >
              <span class="text-capitalize">Okay</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import { createNamespacedHelpers } from "vuex";
const karyawan = createNamespacedHelpers("masterKaryawan");
export default {
  data() {
    return {
      tab: null,
      dates: [],
      tempLogin: JSON.parse(Cookies.get("userdata_login")),
      password: null,
      confirmation: null,
      currentPass: null,
      dialog2: false,
      dialog: false,
      show1: false,
      show2: false,
      errorMessage: null,
      loading: false,
      e1: 1
    };
  },
  watch: {},
  computed: {
    ...karyawan.mapState([])
  },
  components: {},
  mounted() {},
  methods: {
    onTagValueChange(e) {
      this.employeeName = e.employee_name;
      this.posisition = e.posisition;
    },
    closeSuccessNavigate() {
      this.dialog = false;
      setTimeout(() => {
        Cookies.remove("token_hrd");
        Cookies.remove("userdata_login");
        this.$router.go();
      }, 200);
    },
    submitForm() {
      const temp_user = JSON.parse(Cookies.get("userdata_login"));
      // button effect
      this.loading = true;
      var tempProduct = {};
      tempProduct.password_old = this.currentPass;
      tempProduct.password_new = this.password;

      var formData = new FormData();
      for (var key in tempProduct) {
        formData.append(key, tempProduct[key]);
      }
      this.$store.commit("system/SET_IDPASS", temp_user.data.id);
      this.$store.commit("system/SET_TEMPPASSWORD", formData);
      this.$store
        .dispatch("system/updatePassword")
        .then(response => {
          const res = response.data;
          if (res.status) {
            this.dialog = true;
            this.loading = false;
          } else {
            this.dialog2 = true;
            this.loading = false;
          }
        })
        .catch(error => {
          const message = error.response.data.status.message;
          this.errorMessage = message;
          this.dialog2 = true;
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss">
.theme--dark.v-icon {
  color: #000000;
}
.theme--dark.v-icon.v-icon.v-icon--disabled {
  color: rgb(2 2 2 / 31%) !important;
}
</style>
